export default __webpack_public_path__ + "static/media/twitter.f7451717.svg";